export const getEquipmentCategories = () => ({
  inside: [
    'cooking', 'fridge', 'shower_int', 'wc', 'ac', 'heating', 'tv', 'dishes_kit', 'bedding',
  ],
  outside: [
    'side_blind', 'shower_ext', 'sout_luggage', 'solar', 'camping_table', 'barbecue',
  ],
  driving: [
    'automatic_gear',
    'gps',
    'parking_aid_radar',
    'parking_aid_camera',
    'bluetooth',
  ],
  safety: [
    'baby_seat',
    'bicycle',
    'towbar',
  ],
  winter: [
    'winter_tire',
    'winter_chain',
  ],
})
